module.exports = __webpack_public_path__ + "static/media/trophy.a67aa572.svg";